import { render, staticRenderFns } from "./DUploadImage.vue?vue&type=template&id=3a409b0c&scoped=true&"
import script from "./DUploadImage.vue?vue&type=script&lang=js&"
export * from "./DUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./DUploadImage.vue?vue&type=style&index=0&id=3a409b0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a409b0c",
  null
  
)

export default component.exports